import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
  closeOnlyRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
  },
}));
